module.exports = __webpack_public_path__ + "static/media/Servicos4.8274709f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/CadServicos/Servicos4.png
// module id = 2118
// module chunks = 0